import { render, staticRenderFns } from "./Calls.vue?vue&type=template&id=9d9a12f4&scoped=true&"
import script from "./Calls.vue?vue&type=script&lang=js&"
export * from "./Calls.vue?vue&type=script&lang=js&"
import style0 from "../Style/analysis-selection.scss?vue&type=style&index=0&id=9d9a12f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d9a12f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\marketingdatabase-git\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9d9a12f4')) {
      api.createRecord('9d9a12f4', component.options)
    } else {
      api.reload('9d9a12f4', component.options)
    }
    module.hot.accept("./Calls.vue?vue&type=template&id=9d9a12f4&scoped=true&", function () {
      api.rerender('9d9a12f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Customers/Mangl/Modules/AnalysisSelection/Components/Calls.vue"
export default component.exports